<template>
  <v-container id="parentIntro" fluid class="pa-0">
    <v-row class="pt-13">
      <v-col md="6" cols="12" class="text-center text-md-left" :class="[isMobile ? 'parent-intro-section-content-mobile' : 'parent-intro-section-content']">
        <div class="heading-h1 mb-5">Motivate and reward your kids.</div>
        <div class="mb-5">Behavior charts are boring. Our catalog of cool stuff puts pep in their step to complete chores, practice instruments, study harder and even help with remote learning challenges. You set the quest and we speed them on their way with friendly reminders. Huzzah!</div>
        <div class="mb-5">With a bit of pluck and/or elbow grease, they’ll soon be saying OMG to an awesome reward at the door. All with no pleading, begging or bargaining. That’s Easi.</div>
        <div class="mb-5"><b>START YOUR FREE, NO OBLIGATION TRIAL WITH 500 POINTS ON US! Start some quests for your kids today!</b></div>
        <v-btn color="secondary" :to="{ name: 'Signup' }">Try Easi Rewards free</v-btn>
      </v-col>
      <v-col md="6" cols="12">
        <v-img :src="require('@/assets/parent-intro-section-bg-img.jpg')" height="300" contain/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: "ParentIntroSection",

    computed: {
      isMobile() {
        return this.$vuetify.breakpoint.mobile;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .parent-intro-section-small-header {
    font-family: "Lato", sans-serif;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #544837;
  }

  .parent-intro-section-content {
    padding: 0% 0% 5% 10%;
  }

  .parent-intro-section-content-mobile {
    padding: 5% 2%;
  }
</style>



// WEBPACK FOOTER //
// src/components/LandingPage/ParentIntroSection.vue